import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdmisionPersonalRoutingModule } from './AdmisionPersonal-routing.module';

import { MatInputModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSortModule,
  MatTableModule,
  MatSelectModule,
  MatMenuModule,
  MatProgressBarModule,
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatTabsModule,
  MatNativeDateModule,
  MatCardModule,
  MatRadioModule,
  MatIconModule,
  MatDatepickerModule,
  MatAutocompleteModule,
  MatFormFieldModule,
  MatToolbarModule,
  MatDividerModule,
  MatExpansionModule,
  MatSidenavModule,
  MatStepperModule,
  MatTooltipModule,
  MAT_DIALOG_DEFAULT_OPTIONS
} from '@angular/material';
import { PartialsModule } from '../../../partials/partials.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { UtilsHCM_APService } from '../_core/utils/UtilsHCM_AP.service';
import { TrabajadorInfoDialogComponent } from './_shared/trabajador-info-dialog/trabajador-info-dialog.component';
import { ObservacionDialogComponent } from './_shared/observacion-dialog/observacion-dialog.component';
import { ShowFotoDialogComponent } from './_shared/show-foto-dialog/show-foto-dialog.component';
import { TablaMensajesComponent } from './_shared/tabla-mensajes/tabla-mensajes.component';
import { EnableDisabledComponent } from './_shared/enable-disabled/enable-disabled.component';
import { AddEditCargoLaboralComponent } from './_shared/add-edit-cargo-laboral/add-edit-cargo-laboral.component';
import { TablaCargaMasivaComponent } from './_shared/tabla-carga-masiva/tabla-carga-masiva.component';
import { ImportAccionMasivaComponent } from './_shared/import-accion-masiva/import-accion-masiva.component';
import { ResultAccionMasivaComponent } from './_shared/result-accion-masiva/result-accion-masiva.component';
import { AddPersonaBlacklistComponent } from './_shared/add-persona-blacklist/add-persona-blacklist.component';
import { DialogResultadoBlacklistComponent } from './_shared/dialog-resultado-blacklist/dialog-resultado-blacklist.component';
import { FirmaContratoDialogComponent } from './_shared/firma-contrato-dialog/firma-contrato-dialog.component';
// import { SignaturePadModule } from 'angular2-signaturepad';
// import { SignaturePadModule } from 'angular2-signaturepad/angular2-signaturepad';
// import { SignaturePadModule } from 'angular2-signaturepad/angular2-signaturepad';
import { SignaturePad } from 'angular2-signaturepad';
import { DialogProrrogaContratoComponent } from './_shared/dialog-prorroga-contrato/dialog-prorroga-contrato.component';
import { DialogResultProrrogaComponent } from './_shared/dialog-result-prorroga/dialog-result-prorroga.component';
import { AddEditJaladorDialogComponent } from './_shared/add-edit-jalador-dialog/add-edit-jalador-dialog.component';
import { InsertUpdatePersonalActivoComponent } from './_shared/insert-update-personal-activo/insert-update-personal-activo.component';
import { CargaMasivaPersonalComponent } from './_shared/carga-masiva-personal/carga-masiva-personal.component';
import { AddEditAsignacionComponent } from './_shared/add-edit-asignacion/add-edit-asignacion.component';

@NgModule({
    imports: [
      CommonModule,
      AdmisionPersonalRoutingModule,

      PartialsModule,
      FormsModule,
      ReactiveFormsModule,
      MatInputModule,
      MatTableModule,
      MatPaginatorModule,
      MatSortModule,
      MatProgressSpinnerModule,
      MatIconModule,
      MatSelectModule,
      MatMenuModule,
      MatProgressBarModule,
      MatButtonModule,
      MatCheckboxModule,
      MatDialogModule,
      MatTabsModule,
      MatNativeDateModule,
      MatCardModule,
      MatRadioModule,
      MatDatepickerModule,
      MatAutocompleteModule,
      MatFormFieldModule,
      MatStepperModule,
      MatToolbarModule, MatDividerModule, MatExpansionModule,
      AngularFontAwesomeModule,
      MatTooltipModule,
      MatSidenavModule,
      NgxMatSelectSearchModule,
      NgbModule,
      // SignaturePadModule
      // SignaturePadModule
    ],

    providers: [
      {
              provide: MAT_DIALOG_DEFAULT_OPTIONS,
              useValue: {
                  hasBackdrop: true,
                  panelClass: 'm-mat-dialog-container__wrapper',
                  height: 'auto',
                  width: '900px'
              }
      },
      UtilsHCM_APService
    ],
    declarations: [
      TrabajadorInfoDialogComponent,
      ObservacionDialogComponent,
      ShowFotoDialogComponent,
      TablaMensajesComponent,
      EnableDisabledComponent,
      AddEditCargoLaboralComponent,
      TablaCargaMasivaComponent,
      ImportAccionMasivaComponent,
      ResultAccionMasivaComponent,
      AddPersonaBlacklistComponent,
      DialogResultadoBlacklistComponent,
      FirmaContratoDialogComponent,
      DialogProrrogaContratoComponent,
      DialogResultProrrogaComponent,
      AddEditJaladorDialogComponent,
      InsertUpdatePersonalActivoComponent,
      CargaMasivaPersonalComponent,
      AddEditAsignacionComponent, 
      SignaturePad
    ],
    entryComponents: [
      TrabajadorInfoDialogComponent,
      ObservacionDialogComponent,
      ShowFotoDialogComponent,
      TablaMensajesComponent,
      EnableDisabledComponent,
      AddEditCargoLaboralComponent,
      TablaCargaMasivaComponent,
      ImportAccionMasivaComponent,
      ResultAccionMasivaComponent,
      AddPersonaBlacklistComponent,
      DialogResultadoBlacklistComponent,
      FirmaContratoDialogComponent,
      DialogProrrogaContratoComponent,
      DialogResultProrrogaComponent,
      AddEditJaladorDialogComponent,
      InsertUpdatePersonalActivoComponent,
      CargaMasivaPersonalComponent,
      AddEditAsignacionComponent
    ],
    exports: [
      TablaCargaMasivaComponent, 
      SignaturePad
    ]
  })
  export class AdmisionPersonalModule { }
